import { useEffect, useRef, useState } from "react";
import MainButton from "../MainButton/MainButton";
import styles from "./FilterDropdown.module.css";

const FilterDropdown = ({
    label,
    options = [],
    selectedValue,
    onSelect,
    leftIcon,
    leftIconHover,
    leftIconActive,
    rightIcon,
    rightIconHover,
    rightIconActive,
    checkIcon,
    getOptionLabel = (option) => option.label ?? option,
    getOptionValue = (option) => option.value ?? option,
    wrapperClassName = "",
    menuClassName = "",
    itemClassName = "",
    selectedItemClassName = "",
    checkIconClassName = "",
    isMobile = false,
}) => {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const selectedOption = options.find(
        (option) => getOptionValue(option) === selectedValue
    );

    const buttonLabel = selectedOption
        ? getOptionLabel(selectedOption)
        : label;

    return (
        <div
            className={`${styles.dropdownWrapper} ${wrapperClassName}`}
            ref={dropdownRef}
        >
            <MainButton
                data-testid={`filter-dropdown-button-${label}`}
                variant="light"
                active={isOpen}
                onClick={() => setIsOpen((prev) => !prev)}
                className={isMobile ? styles.dropdownButtonMobile : ""}
                leftIcon={leftIcon}
                leftIconHover={leftIconHover}
                leftIconActive={leftIconActive}
                leftIconAlt=""
                rightIcon={rightIcon}
                rightIconHover={rightIconHover}
                rightIconActive={rightIconActive}
                rightIconAlt=""
            >
                {buttonLabel}
            </MainButton>

            {isOpen && (
                <div className={`${styles.dropdownMenu} ${menuClassName}`}>
                    {options.map((option) => {
                        const value = getOptionValue(option);
                        const optionLabel = getOptionLabel(option);
                        const isSelected = value === selectedValue;

                        return (
                            <div
                                key={value}
                                data-testid={`filter-dropdown-option-${label}-${optionLabel}`}
                                className={`
                                    ${styles.dropdownMenuItem}
                                    ${itemClassName}
                                    ${isSelected ? `${styles.selectedItem} ${selectedItemClassName}` : ""}
                                `}
                                onClick={() => {
                                    onSelect(value);
                                    setIsOpen(false);
                                }}
                            >
                                <span>{optionLabel}</span>
                                {isSelected && checkIcon && (
                                    <img
                                        src={checkIcon}
                                        alt="Seleccionado"
                                        className={`${styles.checkIcon} ${checkIconClassName}`}
                                    />
                                )}
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    );
};

export default FilterDropdown;